interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="mt-8 flex flex-wrap items-center justify-center gap-2">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300/70 bg-background-50 px-3 font-label text-sm text-foreground-700 transition-colors enabled:hover:border-primary-300 enabled:hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        <i className="ri-arrow-left-s-line"></i> 上一页
      </button>
      {pages.map((p) => (
        <button
          key={p}
          type="button"
          onClick={() => onChange(p)}
          className={`flex h-9 w-9 items-center justify-center rounded-md font-label text-sm transition-colors cursor-pointer ${
            p === current
              ? 'bg-primary-500 text-background-50'
              : 'border border-background-300/70 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
          }`}
        >
          {p}
        </button>
      ))}
      <button
        type="button"
        disabled={current >= total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 items-center gap-1 rounded-md border border-background-300/70 bg-background-50 px-3 font-label text-sm text-foreground-700 transition-colors enabled:hover:border-primary-300 enabled:hover:text-primary-700 disabled:cursor-not-allowed disabled:opacity-40 cursor-pointer"
      >
        下一页 <i className="ri-arrow-right-s-line"></i>
      </button>
    </div>
  );
}